export default (parser) => {
    const BaseGreyCatVisitor = parser.getBaseCstVisitorConstructorWithDefaults();
    return class GreyCatTypeScriptVisitor extends BaseGreyCatVisitor {
        constructor() {
            super();
            this.validateVisitor();
        }
        greycat(node) {
            const ctx = {
                depth: 0,
                typeFuncDecl: false,
                private: false,
                static: false,
                source: [],
            };
            ctx.depth += 1;
            if (node.stmt) {
                node.stmt.forEach((s) => this.visit(s, ctx));
            }
            ctx.depth -= 1;
            return ctx.source.join('\n');
        }
        stmt(node, ctx) {
            if (node.funcDecl) {
                node.funcDecl.forEach((fDecl) => this.visit(fDecl, ctx));
            }
            if (node.typeDecl) {
                node.typeDecl.forEach((t) => this.visit(t, ctx));
            }
            if (node.assign) {
                node.assign.forEach((a) => this.visit(a, ctx));
            }
            if (node.varDecl) {
                node.varDecl.forEach((v) => this.visit(v, ctx));
            }
            if (node.funcCall) {
                node.funcCall.forEach((f) => this.visit(f, ctx));
            }
            if (node.block) {
                node.block.forEach((b) => this.visit(b, ctx));
            }
        }
        funcStmts(node, ctx) {
            if (node.funcStmt) {
                node.funcStmt.forEach((stmt) => this.visit(stmt, ctx));
            }
        }
        funcStmt(node, ctx) {
            if (node.assign) {
                this.visit(node.assign, ctx);
            }
            else if (node.funcDecl) {
                this.visit(node.funcDecl, ctx);
            }
        }
        block(node, ctx) {
            if (node.funcStmts) {
                this.funcDecl(node, ctx);
            }
            return;
        }
        funcDecl(node, ctx) {
            if (node.funcStmts && node.Identifier && ctx.typeFuncDecl) {
                const fName = node.Identifier[0].image;
                const pDecl = node.paramsDecl ? this.visit(node.paramsDecl, ctx) : [];
                const indent = genIndent(ctx.depth);
                const priv = ctx.private ? 'private ' : '';
                const stc = ctx.static ? 'static ' : '';
                const params = pDecl.map(({ name, type }) => `${name.image}: ${asType(type.image, ctx)}`);
                ctx.source.push(`${indent}${priv}${stc}${fName}(${params.join(', ')}) {}`);
                let pDef = pDecl.map(({ name, type }) => `${name.image}: ${asType(type.image, ctx)}`).join(', ');
                if (pDef.length > 0) {
                    pDef = `/* ${pDef} */`;
                }
                this.visit(node.funcStmts, ctx);
            }
            return;
        }
        paramsDecl(node, ctx) {
            if (node.paramDecl) {
                return node.paramDecl
                    .map((pDecl) => this.visit(pDecl, ctx))
                    .filter((pDecl) => pDecl);
            }
            return [];
        }
        paramDecl(node, ctx) {
            if (node.name && node.type) {
                return {
                    name: node.name[0],
                    type: node.type[0],
                };
            }
            return;
        }
        typeDecl(node, ctx) {
            if (node.Identifier) {
                const name = node.Identifier[0].image;
                ctx.source.push(`export class ${name} {`);
                if (node.typeStmt) {
                    node.typeStmt.map((t) => this.visit(t, ctx));
                }
                ctx.source.push(`}`);
                ctx.source.push('');
            }
            return;
        }
        typeStmt(node, ctx) {
            ctx.private = Boolean(node.Private);
            ctx.static = Boolean(node.Static);
            if (node.attDecl) {
                this.visit(node.attDecl, ctx);
            }
            if (node.funcDecl) {
                ctx.typeFuncDecl = true;
                this.visit(node.funcDecl, ctx);
                ctx.typeFuncDecl = false;
            }
            ctx.private = false;
            ctx.static = false;
        }
        attDecl(node, ctx) {
            if (node.name && node.type) {
                const name = node.name[0].image;
                const type = node.type[0].image;
                const priv = ctx.private ? 'private ' : '';
                if (ctx.static) {
                    if (node.expr) {
                        let initValue;
                        const expr = this.visit(node.expr, ctx);
                        switch (expr.type) {
                            case 'stringLiteral':
                                initValue = expr.value.image;
                                break;
                            case 'number':
                            case 'null':
                            case 'bool':
                                initValue = expr.value;
                                break;
                            case 'qName':
                                initValue = asPath(expr.value);
                                break;
                            case 'funcCall':
                            case 'funcDecl':
                                initValue = '() => {}';
                                break;
                            default:
                                initValue = expr.value;
                                break;
                        }
                        ctx.source.push(`${genIndent(ctx.depth)}${priv}static ${name} = ${initValue};`);
                    }
                }
                else {
                    if (!node.expr) {
                        ctx.source.push(`${genIndent(ctx.depth)}${priv}${name}: ${asType(type, ctx)};`);
                    }
                }
            }
        }
        params(node, ctx) {
            if (node.param) {
                return node.param.map((p) => this.visit(p, ctx)).filter((p) => p);
            }
            return [];
        }
        param(node, ctx) {
            if (node.expr) {
                let name;
                if (node.Identifier) {
                    name = node.Identifier[0];
                }
                const expr = this.visit(node.expr, ctx);
                return { ref: expr, name };
            }
            return;
        }
        expr(node, ctx) {
            if (node.Null) {
                return { type: 'null', value: null, token: node.Null };
            }
            else if (node.False) {
                return { type: 'boolean', value: false, token: node.False };
            }
            else if (node.True) {
                return { type: 'boolean', value: true, token: node.True };
            }
            else if (node.Num) {
                const num = node.Num[0].image;
                let value;
                if (num.indexOf('.') === -1) {
                    value = parseInt(node.Num[0].image, 10);
                }
                else {
                    value = parseFloat(node.Num[0].image);
                }
                return { type: 'number', value, token: node.Num[0] };
            }
            else if (node.newDecl) {
                const token = this.visit(node.newDecl, ctx);
                return { type: 'object', value: token, token };
            }
            else if (node.inlineDecl) {
                return { type: 'object', value: this.visit(node.inlineDecl, ctx), token: node.inlineDecl };
            }
            else if (node.arrayDecl) {
                return { type: 'array', value: this.visit(node.arrayDecl, ctx), token: node.arrayDecl };
            }
            else if (node.funcDecl) {
                return { type: 'function', value: this.visit(node.funcDecl, ctx), token: node.funcDecl };
            }
            else if (node.funcCall) {
                const fCall = this.visit(node.funcCall, ctx);
                if (fCall) {
                    return { type: fCall.type, value: fCall.value, token: node.funcCall };
                }
            }
            else if (node.stringLiteral) {
                const token = this.visit(node.stringLiteral, ctx);
                return { type: 'string', value: token.image, token };
            }
            else if (node.hashRef) {
                return { type: 'hashRef', value: this.visit(node.hashRef, ctx), token: node.hashRef };
            }
            return;
        }
        arrayDecl(node, ctx) {
            if (node.expr) {
                node.expr.map((e) => this.visit(e, ctx));
            }
            return;
        }
        stringLiteral(node) {
            if (node.value) {
                return node.value[0];
            }
            return;
        }
        qName(node) {
            if (node.Identifier) {
                return node.Identifier;
            }
            return;
        }
        hashRef(node) {
            if (node.Identifier) {
                return node.Identifier;
            }
            return;
        }
    };
};
function genIndent(depth) {
    let indent = '';
    for (let i = 0; i < depth; i++) {
        indent += '  ';
    }
    return indent;
}
function asPath(qName) {
    return qName.map((i) => i.image).join('.');
}
function asType(type, ctx) {
    switch (type) {
        case 'string':
            return 'string';
        case 'double':
            ctx.source.push(`${genIndent(ctx.depth)}/** native type: double */`);
            return 'number';
        case 'int':
            ctx.source.push(`${genIndent(ctx.depth)}/** native type: int */`);
            return 'number';
        case 'int_array':
            ctx.source.push(`${genIndent(ctx.depth)}/** native type: int[] */`);
            return 'number[]';
        case 'double_array':
            ctx.source.push(`${genIndent(ctx.depth)}/** native type: double[] */`);
            return 'number[]';
        case 'bool':
            return 'boolean';
        case 'bool_array':
            return 'boolean[]';
        case 'function':
            return '() => void';
        default:
            return type;
    }
}
//# sourceMappingURL=transpiler.js.map